import(/* webpackMode: "eager" */ "/home/runner/work/examanet/examanet/src/app/[locale]/mot-de-passe-oublie/page.tsx");
